module.exports = __webpack_public_path__ + "static/img/home_kol2@2x.d0110d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productIntroduction/home_kol2@2x.png
// module id = 7jev
// module chunks = 0